import * as AvatarPrimitive from "@radix-ui/react-avatar";
import cn from "classnames";
import * as React from "react";

const Avatar = React.forwardRef<
	React.ElementRef<typeof AvatarPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root> & {
		size?: "sm" | "md" | "lg";
		className?: string;
	}
>(({ className, size = "md", ...props }, ref) => {
	let sizeClass = "h-8 w-8";
	if (size === "sm") {
		sizeClass = "h-6 w-6";
	} else if (size === "lg") {
		sizeClass = "h-10 w-10";
	}

	return (
		<AvatarPrimitive.Root
			ref={ref}
			className={cn(
				sizeClass,
				"relative flex shrink-0 overflow-hidden rounded-full",
				className
			)}
			{...props}
		/>
	);
});
Avatar.displayName = AvatarPrimitive.Root.displayName;

const AvatarImage = React.forwardRef<
	React.ElementRef<typeof AvatarPrimitive.Image>,
	React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image> & {
		className?: string;
	}
>(({ className, ...props }, ref) => (
	<AvatarPrimitive.Image
		ref={ref}
		className={cn("aspect-square h-full w-full", className)}
		{...props}
	/>
));
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

const AvatarFallback = React.forwardRef<
	React.ElementRef<typeof AvatarPrimitive.Fallback>,
	React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback> & {
		className?: string;
	}
>(({ className, ...props }, ref) => (
	<AvatarPrimitive.Fallback
		ref={ref}
		className={cn(
			"flex h-full w-full items-center justify-center rounded-full bg-muted",
			className
		)}
		{...props}
	/>
));
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

export { Avatar, AvatarImage, AvatarFallback };
